/** Local flags for guide checklist items not yet inferable from API data. */

const EXPORT_PREVIEW_KEY = 'gb_guide_export_previewed';
const MEMORIAL_EXPLORED_KEY = 'gb_guide_memorial_explored';

/** Alias: walkthrough_seen in product spec maps to onboarding hasSeenWelcome in localStorage. */
export function isWalkthroughSeen() {
  try {
    const raw = localStorage.getItem('generational_bridge_onboarding');
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return Boolean(parsed?.hasSeenWelcome);
  } catch {
    return false;
  }
}

export function markGuideExportPreviewed() {
  try {
    localStorage.setItem(EXPORT_PREVIEW_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function hasGuideExportPreviewed() {
  try {
    return localStorage.getItem(EXPORT_PREVIEW_KEY) === '1';
  } catch {
    return false;
  }
}

export function markGuideMemorialExplored() {
  try {
    localStorage.setItem(MEMORIAL_EXPLORED_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function hasGuideMemorialExplored() {
  try {
    return localStorage.getItem(MEMORIAL_EXPLORED_KEY) === '1';
  } catch {
    return false;
  }
}
